<template>
  <v-navigation-drawer persistent id="LeftDrawer"
    :mini-variant="miniVariant"
    :clipped="clipped"
    v-model="drawer"
    enable-resize-watcher                
    :dark="$vuetify.dark"       
    width="260" app 
  >
    <v-toolbar dense :color="$config.theme.primaryColor" dark>
      <a href="/#/" align-center class="mr-2">
        <img src="logo.png" style="height:40px;" class="mt-1"/>          
      </a>                      
      <v-toolbar-title>
        <span class="body-1"> {{ title }}</span>
      </v-toolbar-title>
    </v-toolbar>
    <div id="left-scroll">     
      <v-img height="90px" :src="require('@/app/assets/cover.jpg')">        
        <v-list-item class="py-2" v-bind:to="{path:'/profile/'}">
          <v-list-item-avatar :color="$config.theme.accentColor">
            <img v-if="user.foto" :src="user.foto" :alt="user.username"/>
            <span v-else class="white--text">{{user.username ? user.username.charAt(0):null}}</span>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="white--text"><strong>{{user.username}}</strong></v-list-item-title>              
            <small class="white--text">
              {{user.roles}}
            </small>              
          </v-list-item-content>
        </v-list-item>
      </v-img> 
      <v-list dense expand>
        <template v-for="(item, i) in menus">          
          <!--group with subitems-->
          <v-list-group v-if="item.children &&  (item.visible == null || item.visible == true)" :key="item.name" :prepend-icon="item.meta ? item.meta.iconClass : ''">
            <template v-slot:activator>                              
              <v-list-item-title>{{ item.displayName }}</v-list-item-title>              
            </template>
            <template v-for="(subItem, i) in item.children">
              <v-divider v-if="i===0" v-bind:key="i"></v-divider>
              <!--sub group-->
              <v-list-group v-if="subItem.children &&  (subItem.visible == null || subItem.visible == true)" :key="subItem.name" sub-group no-action>
                <template v-slot:activator>
                  <v-list-item-content>                  
                    <v-list-item-title class="ml-2">{{subItem.visible}} {{ subItem.displayName }}</v-list-item-title>                  
                  </v-list-item-content>  
                </template>
                <template v-for="(grand, i) in subItem.children" >
                  <router-link v-if="(grand.visible == null || grand.visible == true)" :key="i" :to="{ name: grand.name }"  class="anoline">
                    <v-list-item ripple="ripple" link>                  
                      <v-list-item-icon class="mr-2"></v-list-item-icon>
                      <v-list-item-content><span class="caption">{{ grand.displayName }}</span></v-list-item-content>                  
                      <v-list-item-icon v-if="grand.meta && grand.meta.iconClass">
                        <v-icon>{{ grand.meta.iconClass }}</v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                  </router-link>
                </template>                
              </v-list-group>
              <!--child item-->
              <template v-else>
                <router-link v-if="subItem.visible == null || subItem.visible == true" :key="subItem.name" :to="{name:subItem.name}" class="anoline">
                  <v-list-item link>                               
                    <v-list-item-icon><v-icon>{{subItem.meta ? subItem.meta.iconClass : null}}</v-icon></v-list-item-icon>
                    <v-list-item-content><span class="caption">{{ subItem.displayName }}</span></v-list-item-content>                
                    <!-- <v-circle class="white--text pa-0 circle-pill" v-if="subItem.badge" color="red" disabled="disabled">{{ subItem.badge }}</v-circle> -->
                    <v-list-item-action v-if="subItem.action">
                      <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </router-link>                              
              </template>  
              <v-divider v-if="i===(item.children.length-1)" v-bind:key="i"></v-divider>
            </template>
          </v-list-group>
          <v-subheader v-else-if="item.header" :key="i">{{ item.header }}</v-subheader>
          <v-divider v-else-if="item.divider" :key="i"></v-divider>
          <!--top-level link-->
          <template v-else>
            <v-list-item v-if="item.visible == null || item.visible == true" :key="item.name" :to="{name :item.name}">
              <v-list-item-icon v-if="item.meta && item.meta.iconClass">                
                <v-icon>{{item.meta.iconClass }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ item.displayName }}</v-list-item-title>
              <!-- <v-circle class="white--text pa-0 chip--x-small" v-if="item.badge" :color="item.color || 'primary'" disabled="disabled">{{ item.badge }}</v-circle> -->
              <v-list-item-action v-if="item.subAction">
                <v-icon class="success--text">{{ item.subAction }}</v-icon>
              </v-list-item-action>
              <!-- <v-circle class="caption blue lighten-2 white--text mx-0" v-else-if="item.chip" label="label" small="small">{{ item.chip }}</v-circle> -->
            </v-list-item>
          </template>
        </template>                
      </v-list> 
      <template v-if="user.trial">
        <h4 class="pink--text text-center mt-3">Left trial</h4>
        <base-timer :eventEnd="user.trial" class="mx-auto" />           
      </template>
    </div>
    <v-dialog v-model="dialog" scrollable max-width="300px">      
      <v-card>
        <v-card-title>Select Branch</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <v-radio-group v-model="orgn_id" column>
            <v-radio v-for="(item, index) in orgns" :label="item.name" :value="item.id" v-bind:key="index"></v-radio>            
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" @click="dialog = false">Close</v-btn>         
        </v-card-actions>
      </v-card>
    </v-dialog>    
  </v-navigation-drawer>
</template>
<script>
import User   from '@/utils/models/User'
import config from '@/app/config' 
import { navigationRoutes } from '../NavigationRoutes'
import BaseTimer from "@/app/components/other/BaseTimer"; 
import Model    from '@/app/models/Admin';
let model = new Model();

export default {
  name: 'app-left-drawer',
  components: {
    BaseTimer
  },
  props: {
    expanded: {
      type: Boolean,
      default: true
    },
  },
  data: () => ({    
    dialog: false,
    online : false,  
    title : config.title,
    color: config.color,
    username : null,
    miniVariant:false,
    clipped :false,
    mini: false,
    drawer: true,    
    orgns: [],
    scrollSettings: {
      maxScrollbarLength: 60
    },
    formModel :{
       user_id : null,       
    },
    orgn_id : null,
    user : User.attributes()
  }),  
  computed: {
    computeGroupActive () {
      return true;
    },    
    sideToolbarColor () {
      return this.$vuetify.options.extra.sideNav;
    },
    menus(){            
      return navigationRoutes.routes;//menu.default();
    }
  },
  created () {        
    window.getApp.$on('APP_LEFT_DRAWER_TOGGLED', () => {
      this.drawer = (!this.drawer);
    });
    window.getApp.$on('APP_LEFT_MINI_VARIANT', () => {
      this.miniVariant = (!this.miniVariant);
    });
    window.getApp.$on('APP_LEFT_CLIPPED', () => {
      this.clipped = (!this.clipped);
    });
    window.setInterval(function(){
        this.online = navigator.onLine;
    }, 1000);      
  },
  mounted(){
    return model.profileIndex().then(data=>{        
      Object.assign(this.user, data);              
    });
  },
  methods: {
    genChildTarget (item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component,
        };
      }
      if(!subItem.name){
        return { name: `${item.group}` };
      } else {
        if(item.group){
          return { name: `${item.group}/${(subItem.name)}` };
        } else {
          return { name: `${(subItem.name)}` };
        }
      }
      
    },
    scrollHanle(/*evt*/) {
      
    },       
  }
};
</script>
<style lang="stylus">
  #left-scroll{
    height: calc(100vh - 64px);
    overflow: auto;
  }  
  .anoline{
    text-decoration:none
  }
</style>
